import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { oxygenModel } from '../models/oxygenModel-sidecar'
import { healthBars } from '../indicators/healthBars-sidecar'
import { IMonster } from './monsters'
import { worldSettings } from '../models/worldSettings-sidecar'

export function run(obj: IMonster) {
  let ds = common.getUpdateDeltaScaled()
  let ctx = scene.getContext()

  let needs = worldSettings.getNeeds()

  if (obj.type === 'human') {
    // Consume thirst
    obj.statThirst -= needs.thirstRate * ds
    if (obj.statThirst <= 0) {
      obj.statThirst = 0
      obj.hitPoints -= needs.healthRate * ds
    }
    obj.statHunger -= needs.hungerRate * ds
    if (obj.statHunger <= 0) {
      obj.statHunger = 0
      obj.hitPoints -= needs.healthRate * ds
    }
    obj.statToilet -= needs.toiletRate * ds
    if (obj.statToilet < 0) {
      obj.statToilet = 0
    }
    obj.statEnergy -= needs.energyRate * ds
    if (obj.statEnergy < 0) {
      obj.statEnergy = 0
    }

    // Consume oxygen
    if (obj.isInSuit) {
      obj.statSuitOxygen -= needs.suitOxygenRate * ds
      if (obj.statSuitOxygen <= 0) {
        obj.statSuitOxygen = 0
        obj.statOxygen -= needs.oxygenRate * ds
      }
    } else {
      obj.statSuitOxygen = 0
      obj.statOxygen -= needs.oxygenRate * ds

      let omt = oxygenModel.getTile(ctx.model, obj.i, obj.j)
      if (omt && omt.o2) {
        obj.statOxygen += needs.oxygenRate * ds
      }
    }
    if (obj.statOxygen < 0) {
      obj.hitPoints -= needs.healthRate * 5 * ds
      obj.statOxygen = 0
    }
    if (obj.statOxygen > 100) {
      obj.statOxygen = 100
    }
  }

  healthBars.attach(
    obj.healthBar,
    obj.image.x,
    obj.image.y + 20,
    obj.hitPoints / obj.maxHitPoints,
  )
  obj.healthBar
}
